import intlMessagesEN from './i18n/localization/en.json';
import intlMessagesVi from './i18n/localization/vi.json';

export default {
  name: 'CheckInOut',
  dir: 'CheckInOut',
  pathRoot: 'checkin-out',
  routes: [
    {
      url: '',
      component: 'Page/Checkinout',
      meta: {
        authRoute: true,
      },
      layout: 'FullLayout',
      props: {
        title: 'Check in | Smart Event',
        titleI18n: 'Check in | Smart Event',
        headerStyle: 'fill',
        exact: true,
      },
    },
  ],
  lang: { vi: intlMessagesVi, en: intlMessagesEN },
  isAuthenticate: true,
};
